import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

const AmountTileSimple = ({ active, label, onClick }) => (
    <button
        type="button"
        className={cx(
            'flex flex-col justify-center items-center w-full transition-none text-center bg-white text-center rounded p-8 md:p-6 h-full',
            {
                'text-gray-70 shadow-lg': active,
                'text-gray-30 shadow': !active,
            }
        )}
        onClick={onClick}
    >
        <span className="block text-16 font-medium md:font-bold">{label}</span>
    </button>
);

AmountTileSimple.propTypes = {
    onClick: PropTypes.func.isRequired,
    label: PropTypes.string.isRequired,
    active: PropTypes.bool,
};

AmountTileSimple.defaultProps = {
    active: false,
};

export default AmountTileSimple;
